// Zod schemas para o endpoint público /api/v1/platform/status.
// Devolve flags non sensibles que o frontend usa para decidir entre
// renderizar landing (modo beta privado) ou catálogo normal.
import { z } from 'zod';
export const PlatformStatusResponseSchema = z.object({
    private_beta_mode: z.boolean(),
    registration_open: z.boolean(),
});
//# sourceMappingURL=platform.js.map